import React from 'react';
import { css, cx } from 'emotion';
import { Section } from '@root/src/web/components/Section';
import { LeftColumn } from '@root/src/web/components/LeftColumn';
import { ContainerTitle } from '@root/src/web/components/ContainerTitle';
import { Hide } from '@root/src/web/components/Hide';
import { Flex } from '@root/src/web/components/Flex';
import { space } from '@guardian/src-foundations';
import { from } from '@guardian/src-foundations/mq';
const Container = ({ children, padded, verticalMargins, stretchRight, }) => {
    const containerStyles = css `
		display: flex;
		flex-grow: 1;
		flex-direction: column;
		width: 100%;
	`;
    const margins = css `
		margin-top: ${space[2]}px;
		/*
           Keep spacing at the bottom of the container consistent at 36px, regardless of
           breakpoint, based on chat with Harry Fisher
        */
		margin-bottom: ${space[9]}px;
	`;
    const rightMargin = css `
		${from.wide} {
			margin-right: 68px;
		}
	`;
    const padding = css `
		padding: 0 10px;
	`;
    return (React.createElement("div", { className: cx(containerStyles, padded && padding, verticalMargins && margins, !stretchRight && rightMargin) }, children));
};
export const ContainerLayout = ({ title, fontColour, description, url, sectionId, sideBorders = false, centralBorder, showTopBorder = false, padSides = true, padContent = true, verticalMargins = true, borderColour, backgroundColour, children, leftContent, stretchRight = false, }) => (React.createElement(Section, { sectionId: sectionId, showSideBorders: sideBorders, showTopBorder: showTopBorder, padded: padSides, borderColour: borderColour, backgroundColour: backgroundColour },
    React.createElement(Flex, null,
        React.createElement(LeftColumn, { showRightBorder: centralBorder === 'full', borderColour: borderColour, showPartialRightBorder: centralBorder === 'partial' },
            React.createElement(React.Fragment, null,
                React.createElement(ContainerTitle, { title: title, fontColour: fontColour, description: description, url: url }),
                leftContent)),
        React.createElement(Container, { padded: padContent, verticalMargins: verticalMargins, stretchRight: stretchRight },
            React.createElement(Hide, { when: "above", breakpoint: "leftCol" },
                React.createElement(ContainerTitle, { title: title, fontColour: fontColour, description: description, url: url })),
            children))));
